import React from "react";

export const GOLDEN_HOUR_PHRASE = "Golden Hour";

/** Inline mark for “Golden Hour” in gold */
const GoldenHourMark = ({ className = "" }) => (
  <span className={`sv-golden-hour ${className}`.trim()}>
    {GOLDEN_HOUR_PHRASE}
  </span>
);

const wrapInString = (text, keyPrefix) => {
  if (typeof text !== "string" || !text.includes(GOLDEN_HOUR_PHRASE)) {
    return text;
  }

  const parts = text.split(GOLDEN_HOUR_PHRASE);
  return parts.reduce((nodes, part, i) => {
    if (i === 0) {
      return part ? [part] : [];
    }
    return [
      ...nodes,
      <GoldenHourMark key={`${keyPrefix}-${i}`} />,
      ...(part ? [part] : []),
    ];
  }, []);
};

/**
 * Wrap every occurrence of GOLDEN_HOUR_PHRASE with .sv-golden-hour.
 * Accepts a string or an array of nodes (e.g. from highlightAer).
 */
export const highlightGoldenHour = (input) => {
  if (typeof input === "string") {
    return wrapInString(input, "gh");
  }

  if (Array.isArray(input)) {
    return input.flatMap((node, i) => {
      if (typeof node !== "string") return [node];
      const wrapped = wrapInString(node, `gh-${i}`);
      return Array.isArray(wrapped) ? wrapped : [wrapped];
    });
  }

  return input;
};

export default GoldenHourMark;
